<div class="mt-10 d-flex pt-5 pb-10 pr-10 pl-0 headerBreadcrumb">
  <!-- <img src="./assets/icon/backArrow.svg" class="cp" /> -->
  <label class="font_semibold fs-18 ml-10 mt-5 black_color">
    <span class="cp">{{ candidateName }}</span> /
    <span [style.color]="buttonColorName">{{ interviewRound }}</span>
  </label>

  <!-- Unauthorized Evaluator -->
  <div *ngIf="isEvaluatorUnauthorized" class="text-danger p-4 fs-16">
    ❌ You are not authorized to evaluate this round.
  </div>
  <!-- Deleted Round Message -->
  <div *ngIf="isRoundDeleted" class="text-danger p-4 fs-16">
    ⚠️ This interview round is deleted. Evaluation is not available.
  </div>

  <!-- Position Closed Message -->
  <div *ngIf="isPositionClosed" class="text-warning p-4 fs-16">
    ⚠️ This position is already closed. Evaluation is not allowed.
  </div>
  <div *ngIf="!isAlreadyEvaluated && (finalStatus === 'Hired' || finalStatus === 'Rejected')" class="p-4 fs-16"
    [ngClass]="{ 
       'text-success': finalStatus === 'Hired', 
       'text-danger': finalStatus === 'Rejected' 
     }">
    <ng-container [ngSwitch]="finalStatus">
      <span *ngSwitchCase="'Hired'">✅ Candidate is <strong>Hired</strong>. Further evaluation is locked.</span>
      <span *ngSwitchCase="'Rejected'">❌ Candidate is <strong>Rejected</strong>. Further evaluation is not
        allowed.</span>
    </ng-container>
  </div>
</div>

<!-- Evaluation Form -->
<form *ngIf="evaluationForm && !isEvaluatorUnauthorized && !isRoundDeleted && !isPositionClosed   && !finalStatus "
  [formGroup]="evaluationForm" (ngSubmit)="onSubmit()">
  <div formArrayName="competencies">
    <div *ngFor="let compGroup of competenciesForm.controls; let i = index; trackBy: trackByIndex" [formGroupName]="i"
      class="cardBox mt-10">
      <!-- Competency Header -->
      <div class="cardBoxHeading font_medium fs-14">
        <ion-row class="pl-5">
          <ion-col size="12">
            <div class="fs-14">{{ compGroup.get('competencyName')?.value }}</div>
          </ion-col>
        </ion-row>
      </div>

      <!-- Questions Loop -->
      <div class="pl-10 pr-10 pt-10" formArrayName="questions">
        <div *ngFor="let questionGroup of getQuestions(i).controls; let j = index; trackBy: trackByIndex"
          [formGroupName]="j" class="cardBox mb-15">
          <div class="pl-10 pr-10 pt-10 pb-10">
            <!-- Question Text -->
            <div class="fs-14 mb-10">{{ questionGroup.get('text')?.value }}</div>

            <div class="rating-options d-flex gap-10">
              <div *ngFor="let rating of ratingDefinitions; trackBy: trackByRating" class="rating-box-wrapper">
                <!-- Rating Box -->
                <div class="rating-box"
                  [class.selected]="questionGroup.get('selectedRating')?.value === rating.ratingValue"
                  [class.disabled-box]="questionGroup.disabled"
                  (click)="!questionGroup.disabled && questionGroup.get('selectedRating')?.setValue(rating.ratingValue)">
                  <div class="rating-value">{{ rating.ratingValue }}</div>
                </div>

                <!-- Label outside -->
                <div class="rating-label">{{ rating.label }}</div>
              </div>
            </div>

            <!-- Validation error -->
            <div class="error-text"
              *ngIf="questionGroup.get('selectedRating')?.invalid && questionGroup.get('selectedRating')?.touched">
              Rating is required
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- ================= TECH POSITIONS ================= -->
  <div formArrayName="techPositions" class="mt-20">
    <div *ngFor="let tpGroup of techPositionsForm.controls; let k = index; trackBy: trackByIndex" [formGroupName]="k"
      class="cardBox mt-10">

      <!-- Tech Position Header -->
      <div class="cardBoxHeading font_medium fs-14">
        <ion-row class="pl-5">
          <ion-col size="12">
            <div class="fs-14">{{ tpGroup.get('techPosition')?.value }}</div>
          </ion-col>
        </ion-row>
      </div>

      <!-- Questions Loop -->
      <div class="pl-10 pr-10 pt-10" formArrayName="questions">
        <div *ngFor="let questionGroup of getTechQuestions(k).controls; let q = index; trackBy: trackByIndex"
          [formGroupName]="q" class="cardBox mb-15">

          <div class="pl-10 pr-10 pt-10 pb-10">
            <!-- Question Text -->
            <div class="fs-14 mb-10">{{ questionGroup.get('questions')?.value }}</div>

            <!-- Rating Based -->
            <ng-container *ngIf="isRatingBased(questionGroup)">
              <div class="rating-options d-flex gap-10">
                <!-- <div 
                  *ngFor="let rating of ratingDefinitions; trackBy: trackByRating" 
                  class="rating-box-wrapper"
                > -->
                <div *ngFor="let rating of questionGroup.get('ratings')?.value; trackBy: trackByRating"
                  class="rating-box-wrapper">
                  <!-- Rating Box -->
                  <div class="rating-box"
                    [class.selected]="questionGroup.get('selectedRating')?.value === rating.ratingValue"
                    [class.disabled-box]="questionGroup.disabled"
                    (click)="!questionGroup.disabled && questionGroup.get('selectedRating')?.setValue(rating.ratingValue)">
                    <div class="rating-value">{{ rating.ratingValue }}</div>
                  </div>

                  <!-- Label outside -->
                  <div class="rating-label">{{ rating.label }}</div>
                </div>
              </div>

              <!-- Validation error -->
              <div class="error-text"
                *ngIf="questionGroup.get('selectedRating')?.invalid && questionGroup.get('selectedRating')?.touched">
                Rating is required
              </div>

            </ng-container>

            <!-- Open Ended -->
            <ng-container *ngIf="isOpenEnded(questionGroup)">
              <mat-form-field class="w-100 mat-input-style mt-10">
                <textarea matInput formControlName="comment" placeholder="Enter Comment" rows="3"></textarea>
                <mat-error *ngIf="questionGroup.get('comment')?.hasError('maxlength')">
                  Cannot exceed {{ maxCommentLength }} characters.
                </mat-error>
              </mat-form-field>
            </ng-container>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- Submit Button -->
  <div class="d-flex justify-content-end mt-20 pr-10 ml-10">
    <button class="add_btn fs-14 ml-10 mb-20" *ngIf="!isAlreadyEvaluated" [style.background-color]="buttonColorName"
      type="submit">
      Submit
    </button>
  </div>
  <div *ngIf="isAlreadyEvaluated" class="text-success" style="padding: 20px;">
    Evaluated by <strong>{{ evaluatedByName }}</strong>
  </div>
</form>